import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface GenerateButtonProps {
  onClick?: () => void
  disabled?: boolean
  isLoading?: boolean
  loadingText?: string
  children: React.ReactNode
  className?: string
}

export function GenerateButton({
  onClick,
  disabled = false,
  isLoading = false,
  loadingText = 'Generating...',
  children,
  className,
}: GenerateButtonProps) {
  const isDisabled = disabled || isLoading

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        "relative py-3 px-6 rounded-xl font-medium overflow-hidden",
        "transition-all duration-700 ease-out",
        !isDisabled
          ? "bg-gradient-to-br from-[#888888] via-white via-50% to-[#888888] text-black shadow-[0_0_20px_rgba(255,255,255,0.15)] hover:shadow-[0_0_30px_rgba(255,255,255,0.25)] hover:scale-[1.02] active:scale-[0.98] animate-gradient"
          : "bg-white/[0.04] text-white/20 cursor-not-allowed scale-100",
        className
      )}
    >
      <span
        className={cn(
          "relative z-10 flex items-center justify-center gap-2 transition-opacity duration-300",
          !isDisabled ? "opacity-100" : "opacity-60"
        )}
      >
        {isLoading ? (
          <>
            <Loader2 className="size-5 animate-spin" />
            {loadingText}
          </>
        ) : (
          children
        )}
      </span>

      {/* Shimmer effect */}
      <div
        className={cn(
          "absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full pointer-events-none",
          "transition-transform duration-1000 ease-out",
          !isDisabled && "animate-shimmer"
        )}
      />
    </button>
  )
}
